module.exports = __webpack_public_path__ + "static/media/0097_Small.47d5cd27.jpg";